import React, {PureComponent} from 'react';

import styles from './styles';

export default class Tab extends PureComponent {

  render() {
    const {id, selected} = this.props;

    return (
      <div id={id} className={`${styles.tab} ${selected ? 'selected' : ''}`}>
        {this.props.children}
      </div>
    );
  }
}

Tab.displayName = 'Tab';



// WEBPACK FOOTER //
// ./src/components/BarTab/Tab.jsx